import { useLocation } from 'react-router';

export const useQuery = () => {
  const location = useLocation();
  return {
    pathname: location.pathname.split('?')[0],
    params: new URLSearchParams(location.search),
  };
};
